import { t } from 'i18next';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import {
  FaAngleDownRegularSvgIcon,
  FaLocationDotRegularSvgIcon,
  FaLocationPinRegularSvgIcon,
} from '../../assets/icons/svgs';
import { RootState } from '../../redux/store';
import { borderRadius } from '../../theme/borderRadius';
import { colors } from '../../theme/colors';
import spacing, { isMobileScreen, spacingInUnits } from '../../theme/spacing';
import { fontSize } from '../../theme/typography';
import { MainButton } from '../Buttons/MainButton';
import { DEFAULT_MIN_INPUT_WIDTH } from '../FormikForm/constants';
import LabelText from '../FormikForm/LabelText';
import {
  formikFieldBaseStyles,
  formikTopLabelAbsoluteStyles,
} from '../FormikForm/styles';
import { useLocationSelectorContext } from './LocationSelectorContext';

const startIconStyles: CSSProperties = {
  color: colors.textPrimary,
  marginRight: spacing.small,
  bottom: 1,
  position: 'relative',
};

const horizontalButtonPadding = spacingInUnits.smallMedium;

const OpenLocationSelectionButton = ({
  buttonStyles,
}: {
  buttonStyles?: CSSProperties;
}) => {
  const userLocations = useSelector((state: RootState) => state.user.locations);

  const {
    setIsChangeLocationModalOpen,
    setIsAddNewLocationModalOpen,
    selectedLocation,
    showError,
  } = useLocationSelectorContext();

  const hasUserNoLocationsSet =
    !userLocations || userLocations.length === 0 || !selectedLocation;

  const cityToVillage = !selectedLocation?.region
    ? selectedLocation?.cityToVillage || ''
    : '';

  const formattedLocation = `${
    selectedLocation?.region || ''
  } ${cityToVillage}`;

  if (hasUserNoLocationsSet) {
    return (
      <div
        style={{
          position: 'relative',
        }}
      >
        {showError && (
          <LabelText
            text={t('common.fillFieldToContinue')}
            error={true}
            style={formikTopLabelAbsoluteStyles}
          />
        )}
        <MainButton
          fullWidth={isMobileScreen}
          variant="outlined"
          style={{
            ...formikFieldBaseStyles,
            fontSize: fontSize.input,
            color: colors.textGreyMedium,
            minWidth: isMobileScreen ? '100%' : DEFAULT_MIN_INPUT_WIDTH,
            paddingTop: horizontalButtonPadding,
            paddingBottom: horizontalButtonPadding,
            justifyContent: 'space-between',
            ...buttonStyles,
            ...(showError ? { border: `solid 1px ${colors.redLight}` } : {}),
          }}
          endIcon={
            <FaLocationDotRegularSvgIcon
              size={fontSize.lg}
              style={{
                color: colors.textGreyMedium,
              }}
            />
          }
          text={t('location.chooseLocation')}
          onClick={() => setIsAddNewLocationModalOpen(true)}
        />
      </div>
    );
  }

  const StartIcon = selectedLocation?.isApproximateByDevice ? (
    <FaLocationDotRegularSvgIcon size={fontSize.lg} style={startIconStyles} />
  ) : (
    <FaLocationPinRegularSvgIcon size={fontSize.lg} style={startIconStyles} />
  );

  return (
    <MainButton
      fullWidth={isMobileScreen}
      typeStyle="secondary"
      style={{
        ...formikFieldBaseStyles,
        fontSize: fontSize.input,
        textTransform: 'none',
        paddingTop: horizontalButtonPadding,
        paddingBottom: horizontalButtonPadding,
        minWidth: isMobileScreen ? '100%' : DEFAULT_MIN_INPUT_WIDTH,
        justifyContent: 'space-between',
        ...buttonStyles,
      }}
      // startIcon={StartIcon}
      endIcon={
        <FaAngleDownRegularSvgIcon
          size={fontSize.md}
          style={{
            color: colors.textPrimary,
          }}
        />
      }
      onClick={() => setIsChangeLocationModalOpen(true)}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        {StartIcon}
        {formattedLocation}
      </div>
    </MainButton>
  );
};

export default OpenLocationSelectionButton;
